// extracted by mini-css-extract-plugin
module.exports = {"socialItem":"social-list_socialItem__1OYe4"};